export default __webpack_public_path__ + "static/media/icon-verydissatisfied-active.f3c02b66.svg";